import React from "react";

interface Props {
  onClick: () => void;
}

export function LoginBtn({ onClick }: Props) {
  return (
    <button
      className="h-[57px] w-full bg-blue-1 text-[20px] leading-[25px] text-white"
      onClick={onClick}
    >
      로그인
    </button>
  );
}
